import styles from './DocPageSeparator.module.scss';

const DocPageSeparator = () => <div className={styles.DocPageSeparator} />;

export default DocPageSeparator;
